import { jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { Alignment } from "../../foundations/alignment.es.js";
import { LineHeight } from "../../foundations/typography.es.js";
import { styled } from "@mui/material";
import { forwardRef } from "react";
import { styledOptions } from "../../utils/styled-options/styled-options.es.js";
import { MuiClassCollection } from "../../foundations/mui-class-collection.es.js";
import MuiTab from "../../../node_modules/@mui/material/Tab/Tab.es.js";
import { CursorStyle } from "../../foundations/cursor-style.es.js";
import { Displaying } from "../../foundations/displaying.es.js";
const StyledTab = styled(MuiTab, styledOptions)(({
  theme,
  color,
  icon
}) => {
  const selectedColor = color ? theme.palette[color].main : theme.palette.primary.main;
  return {
    [`&.${MuiClassCollection.selected}`]: {
      color: selectedColor
    },
    [`&.${MuiClassCollection.disabled}`]: {
      cursor: CursorStyle.notAllowed,
      pointerEvents: "all",
      color: theme.palette.text.disabled
    },
    display: Displaying.flex,
    alignItems: Alignment.center,
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightMedium,
    minWidth: 60,
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    lineHeight: LineHeight["md"],
    minHeight: icon ? 0 : void 0,
    ...icon && {
      "& .MuiTab-iconWrapper": {
        height: 24,
        hidth: 24
      }
    }
  };
});
const Tab = forwardRef(function Tab2({
  color,
  icon,
  iconPosition,
  leftIcon,
  rightIcon,
  ...rest
}, ref) {
  const currentIcon = leftIcon ?? rightIcon;
  const currentIconPosition = leftIcon ? "start" : "end";
  return /* @__PURE__ */ jsx(StyledTab, { color, ref, icon: currentIcon, iconPosition: currentIconPosition, ...rest });
});
export {
  Tab
};
//# sourceMappingURL=tab.es.js.map
